import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTitle } from '../../hooks';
import { Grid, CircularProgress } from '@mui/material';
import logo from '../../assets/pictures/agrowelogogreen.png';
import { auth } from '../../utils/api';
import colors from '../../assets/colors';

export default function ActivationAccount(props) {
  const history = useHistory();
  useTitle(props.title);
  useEffect(() => {
    const body = {
      code: window.location.pathname.split('/').pop(),
    };
    auth
      .activate(body)
      .then((result) => {
        if (result.status === 200) {
          setTimeout(() => {
            history.push('/login');
          }, 1000);
        }
      })
      .catch((error) => {
        try {
          if (error.response.status === 403) {
            alert('Użytkownik nie istnieje');
          } else if (error.response.status === 500) {
            alert('Wystąpił błąd serwera, spróbuj ponownie');
          }
        } catch (e) {}
      });
  }, [history]);

  return (
    <Grid
      container
      spacing={4}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={12}>
        <img src={logo} alt="logo" height={'200vh'} />
      </Grid>
      <Grid item xs={12}>
        <h1 align={'center'} sx={{ color: colors.oldAgroweGreen }}>
          Aktywacja konta w toku
        </h1>
      </Grid>
      <Grid item xs={12}>
        <h1 align={'center'}>
          <CircularProgress sx={{ color: colors.oldAgroweGreen }} size={60} />
        </h1>
      </Grid>
    </Grid>
  );
}
